import React from 'react';
import Header from './components/Header'; // importa o seu componente
import Hero from './components/HeroSection/Hero';
import Franquia from './components/Franquia';
import Indicadores from './components/Indicadores';
import Funcionalidades from './components/Funcionalidades';
import Clientes from './components/Clientes'
import Planos from './components/Planos'
import Depoimentos from './components/Depoimentos'
import Footer from './components/Footer'
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Franquia />
      <Indicadores />
      <Funcionalidades />
      <Clientes />
      <Planos />
      <Depoimentos />
      <Footer />
    </div>
  );
}

export default App;
